// ProgressBars.js
// 从 App.js 抽取出的「学习进度 / 削词(句)进度」双进度条组件
// 学单词、学句子（以及以后新增的学习模式）都可以复用同一份样式

import React from 'react';

function ProgressBars({
  isMobile,
  bar1Label,
  bar1Current,
  bar1Total,
  bar1Percent,
  bar2Label,
  bar2Current,
  bar2Total,
  bar2Percent,
}) {
  const progressContainerStyle = {
    margin: isMobile ? '20px 10px' : '10px 0',
  };

  return (
    <div style={progressContainerStyle}>
      <p style={{ fontSize: isMobile ? '0.9em' : '1em' }}>
        {bar1Label} ({bar1Current}/{bar1Total}): {bar1Percent}%
      </p>
      <progress
        value={bar1Current}
        max={bar1Total || 1}
        className="custom-progress"
      />

      <p style={{ fontSize: isMobile ? '0.9em' : '1em', marginTop: '15px' }}>
        {bar2Label} ({bar2Current}/{bar2Total}): {bar2Percent}%
      </p>
      <progress
        value={bar2Current}
        max={bar2Total || 1}
        className="custom-progress"
      />
    </div>
  );
}

export default ProgressBars;
